import { render, staticRenderFns } from "./MyQuizzes.vue?vue&type=template&id=5f7c0ed3&scoped=true&"
import script from "./MyQuizzes.vue?vue&type=script&lang=js&"
export * from "./MyQuizzes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c0ed3",
  null
  
)

export default component.exports